import { AbstractControl } from '@angular/forms';

export function isControlOptional(control: AbstractControl | null): boolean {
	if (control) {
		if (control.validator) {
			const validator = control.validator({} as AbstractControl);

			if (validator && validator['required']) {
				return false;
			}
		}
	}

	return true;
}
